<template>
    <div>
        <app-sub-title text="Filtros" />
        <div class="d-flex align-items-center">
            <div class="px-2">
                <app-form-select-input 
                    :options="menus"
                    v-model="filters.menu"
                    placeholder="Menú"
                />
            </div>
            <div class="px-2">
                <app-form-text-input 
                    v-model="filters.name"
                    placeholder="Nombre"
                />
            </div>
            <div class="px-2">
                <app-form-text-input 
                    v-model="filters.to"
                    placeholder="Nombre de la página"
                />
            </div>
            <div class="px-2">
                <b-button variant="primary" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
            </div>
            <div class="px-2">
                <b-button variant="secondary" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
            </div>
        </div>
    </div>
</template>
<script>
import permisionManagerRepository from '../../../../repositories/permissionManager.repository';
export default {
    data(){
        return {
            filters: {
                name: '',
                to: '',
                menu: ''
            },
            menus: []
        }
    },
    methods: {
        clearFilters(){
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        },
        loadMenus(){
            const pmr = {...permisionManagerRepository};
            pmr.getAllMenus()
            .then(menus => this.menus = menus)
            .catch(error => toastr.error('Ocurrió un error al cargar los menus'));
        },
        initialize(){
            this.loadMenus();
        }
    },
    created(){
        this.initialize();
    }
}
</script>
